import css from 'styled-jsx/css';

const staticStyles = css.global`
  .SubIBProgramsTree {
    background: white;
    border-radius: 16px;
    border: 1px solid rgba(44, 0, 143, 0.2);
    padding: 16px;
    min-width: 250px;
    max-width: 320px;
    height: fit-content;
    position: sticky;
    top: 20px;
  }

  .SubIBProgramsTree .tree-title {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.32;
    margin: 0 0 16px 0;
    color: #333;
  }

  .SubIBProgramsTree .tree-node {
    position: relative;
    padding-left: 16px;
  }

  .SubIBProgramsTree .tree-node-root {
    padding-left: 0;
  }

  .SubIBProgramsTree .tree-node-content {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    user-select: none;
  }

  .SubIBProgramsTree .tree-node-content:hover {
    background-color: rgba(44, 0, 143, 0.06);
  }

  .SubIBProgramsTree .tree-node-content.active {
    background-color: rgba(44, 0, 143, 0.12);
    color: #2c008f;
  }

  .SubIBProgramsTree .tree-toggle {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #666;
    transition: transform 0.2s ease;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .SubIBProgramsTree .tree-toggle.expanded {
    transform: rotate(90deg);
  }

  .SubIBProgramsTree .tree-toggle.hidden {
    visibility: hidden;
  }

  .SubIBProgramsTree .tree-node-name {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.4;
    color: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .SubIBProgramsTree .tree-node-root-name {
    color: #2C008F;
    font-size: 14px;
    font-weight: 700;
  }

  .SubIBProgramsTree .tree-children {
    overflow: hidden;
    transition: max-height 0.25s ease;
  }

  .SubIBProgramsTree .tree-children.collapsed {
    max-height: 0;
  }

  .SubIBProgramsTree .tree-children.expanded {
    max-height: 2000px;
  }

  .SubIBProgramsTree .tree-line {
    position: absolute;
    left: 7px;
    top: 28px;
    bottom: 8px;
    width: 1px;
    background: rgba(0, 0, 0, 0.12);
  }
`;

export { staticStyles };
